import { Link } from "react-router-dom";
import { Medal } from "lucide-react";

export const Footer = ({ onEnroll }) => (
  <footer
    data-testid="site-footer"
    className="relative bg-[#050505] border-t border-white/10 px-6 md:px-12 py-16"
  >
    <div className="mx-auto max-w-[1600px] grid gap-12 md:grid-cols-3">
      <div>
        <img
          src="/logo.png"
          alt="Delta DL Enterprise, LLC"
          className="h-28 w-auto rounded-lg bg-white px-4 py-3"
        />
        <p className="mt-6 max-w-sm text-white/50 leading-relaxed">
          A studio for serious learners. Nursing, Algebra, Literature, Art, and
          Leadership — taught with craft and conviction.
        </p>
        <p data-testid="footer-veteran-badge" className="mt-4 inline-flex items-center gap-2 rounded-full border border-[#C9A227]/40 bg-[#C9A227]/10 px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.25em] text-[#C9A227]">
          <Medal size={13} />
          Veteran-Owned Business
        </p>
      </div>

      <div className="space-y-3">
        <div className="text-xs uppercase tracking-[0.3em] text-white/40">Contact</div>
        <a href="mailto:Deltadlenterprise2026@gmail.com" className="block text-white/80 hover:text-white transition-colors">Deltadlenterprise2026@gmail.com</a>
        <a href="tel:+18133089628" className="block text-white/80 hover:text-white transition-colors">(813) 308-9628</a>
        <p className="text-white/50">Mon–Fri · 9am to 6pm</p>
      </div>

      <div className="space-y-4">
        <div className="text-xs uppercase tracking-[0.3em] text-white/40">Get Started</div>
        <button
          data-testid="footer-enroll-btn"
          onClick={onEnroll}
          className="magnetic-btn rounded-full bg-[#7C3AED] px-8 py-3 text-sm font-medium uppercase tracking-wider text-white hover:bg-white hover:text-black"
        >
          Apply Now
        </button>
        <div>
          <Link
            data-testid="footer-admin-link"
            to="/admin/login"
            className="text-xs uppercase tracking-[0.2em] text-white/30 hover:text-white/60 transition-colors"
          >
            Admin Portal
          </Link>
        </div>
      </div>
    </div>

    <div className="mx-auto max-w-[1600px] mt-16 flex flex-col md:flex-row justify-between gap-4 border-t border-white/10 pt-8 text-xs uppercase tracking-widest text-white/30">
      <span>© {new Date().getFullYear()} DeltaDL Enterprise</span>
      <span data-testid="footer-veteran-line" className="text-[#C9A227]/70">A Veteran-Owned Business</span>
      <span>Learn boldly.</span>
    </div>
  </footer>
);

export default Footer;
